import { formatDateToLocalString } from './dateUtils';

/** Bugünün YYYY-MM-DD anahtarı (Istanbul / UTC+3). */
export const getTodayKeyIstanbul = (now = new Date()) => {
  const istanbul = new Date(now.getTime() + 3 * 60 * 60 * 1000);
  const y = istanbul.getUTCFullYear();
  const m = String(istanbul.getUTCMonth() + 1).padStart(2, '0');
  const d = String(istanbul.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

const getJobDueKey = (job) => {
  const due = job?.DueDate ?? job?.dueDate;
  if (!due) return null;
  try {
    const key = formatDateToLocalString(due);
    if (key && /^\d{4}-\d{2}-\d{2}/.test(key)) return key.slice(0, 10);
  } catch (_) { /* ignore */ }
  return null;
};

/**
 * Son tarihi bugün olan işler için yapılmış / yapılmamış özeti.
 * Yapılmış: IsCompleted === true
 */
export const computeDailyJobStats = (jobs, now = new Date()) => {
  const todayKey = getTodayKeyIstanbul(now);
  const list = Array.isArray(jobs) ? jobs : [];
  const todayJobs = list.filter((j) => getJobDueKey(j) === todayKey);
  const done = todayJobs.filter((j) => !!(j.IsCompleted ?? j.isCompleted)).length;
  const pending = todayJobs.length - done;
  const total = todayJobs.length;
  const percent = total > 0 ? Math.round((done / total) * 100) : 0;
  return { todayKey, total, done, pending, percent };
};
